import gql from 'graphql-tag';

export default gql`
  mutation removeByIdLessonExerciseMutation($_id: MongoID!) {
    removeByIdLessonExerciseMutation(_id: $_id) {
      recordId
    }
  }
`;
